import * as HANDLERS from '@/helpers/types/handlers';

const inputEventsMixin = {
  methods: {
    changeEvents: async function () {
      if (this.schema.visible && this.schema.fill.length > 0)
        this.$store.dispatch('page/lookup', { fill: this.schema.fill, model: this.model, info: this.formOptions });

      if (this.schema.hasConditions) this.$store.dispatch('page/conditions', this.formOptions);

      if (this.schema.actionEvent) {
        const actions = await this.$store.getters['page/actions_scheme'](this.formOptions);
        let action = actions.items.find(x => x.name === this.schema.actionEvent);
        action.mode = this.formOptions.mode;

        this.$emit(HANDLERS.EXECUTE_ACTION, { action, origin: this.formOptions.page });
      }
    }
  }
};

export default inputEventsMixin;
